import React, {useContext, useEffect, useState, createContext} from 'react';
import {checkVersion, subscribeToVersionChange} from 'utils/functions/checkVersion';
import {registerServiceWorker, getWb} from 'utils/serviceWorker/registerServiceWorker';

const UpdateContext = createContext<{
    update: boolean;
    apply: () => void;
} | null>(null);

export const useAppUpdate = () => {
    const ctx = useContext(UpdateContext);
    if (!ctx) throw new Error('useAppUpdate must be inside <AppUpdateProvider>');
    return ctx;
};

export const AppUpdateProvider = ({children}: {children: React.ReactNode}) => {
    const [update, setUpdate] = useState(false);

    useEffect(() => {
        registerServiceWorker(
            () => setUpdate(true),
            () => window.location.reload(),
        );
        // подключаем опрос версии как запасной механизм
        subscribeToVersionChange(() => setUpdate(true));
        const interval = setInterval(() => checkVersion(), 2 * 60 * 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        navigator.serviceWorker.addEventListener('message', (event) => {
            if (event.data?.type === 'VERSION_UPDATED') {
                localStorage.setItem('app_version', event.data.version); //записываем версию чтобы checkVersion не дублировал показ моадлки
            }
        });
    }, []);

    const apply = () => {
        const wb = getWb();
        if (!wb) return;

        wb.addEventListener('controlling', () => {
            window.location.reload();
        });

        wb.messageSkipWaiting();
    };

    return <UpdateContext.Provider value={{update, apply}}>{children}</UpdateContext.Provider>;
};
